import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalFormContainerComponent } from '../../../../../../components/ui/modal-form-container/modal-form-container.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ITag } from '../../../../../../types/contactModule';

@Component({
  selector: 'message-selected-tags',
  standalone: true,
  imports: [ModalFormContainerComponent, MatTooltipModule],
  templateUrl: './message-selected-tags.component.html',
  styleUrls: ['./message-selected-tags.component.css', '../selected-list.css'],
})
export class MessageSelectedTagsComponent {
  constructor() {}

  @Input() open: boolean = false;
  @Output() close = new EventEmitter();
  @Input() selectedTags: ITag[] = [];
  @Output() removeTag = new EventEmitter<ITag>();

  handleRemoveTag(item: ITag) {
    this.removeTag.emit(item);
  }

  closeModal() {
    this.close.emit();
  }
}
